var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"menu-item",attrs:{"role":"menuitem","tabindex":"-1"},on:{"click":_vm.emitClick}},[_vm._v(_vm._s(_vm.buttonLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }